/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * When the publisher payout for a rate is due.
 */
export type PaymentMoment = typeof PaymentMoment[keyof typeof PaymentMoment];


export const PaymentMoment = {
  progressive: 'progressive',
  upfront: 'upfront',
} as const;
